<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relatório Receitas - ADAB</div>
            <div class="subTitulo"
              >Gere aqui o arquivo de movimentação - ADAB</div
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Inicial">
              <date-picker
                id="input-2"
                v-model="estoqueRequest.data_inicial"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{
                  empty: isSubmit && estoqueRequest.data_inicial === '',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Data Final">
              <date-picker
                id="input-2"
                v-model="estoqueRequest.data_final"
                :first-day-of-week="0"
                format="YYYY-MM-DD"
                value-type="format"
                lang="pt-br"
                placeholder="dd/mm/yyyy"
                :class="{
                  empty: isSubmit && estoqueRequest.data_final === '',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <button class="btn btn-webreceita" @click="gerar">Gerar</button>
          </div>
        </div>
      </div>
      <b-modal id="rel-ba" size="xl" title="Relatório de estoque">
        <RelEstoqueBa
          :estoques="estoques"
          :semestre="estoqueRequest.semestreSelected"
          :data="estoqueRequest.data_final"
        ></RelEstoqueBa>
        <vue-html2pdf
          style="display: none"
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :pdf-quality="2"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          :html-to-pdf-options="htmlToPdfOptions"
          :manual-pagination="false"
          @beforeDownload="beforeDownload($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <RelEstoqueBa
              :estoques="estoques"
              :semestre="estoqueRequest.semestreSelected"
              :data="estoqueRequest.data_final"
            ></RelEstoqueBa>
          </section>
        </vue-html2pdf>
        <template v-slot:modal-footer="">
          <b-button class="mt-3 ml-4" @click="generateReport">
            Imprimir Relátorio</b-button
          >
        </template>
      </b-modal>
      <loading
        :active.sync="isLoading"
        color="#008e75"
        :can-cancel="true"
      ></loading>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

import RelEstoqueBa from '@/src/components/rel-ba.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import arquivo from '@/src/services/arquivo'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: { Layout, Loading, DatePicker, RelEstoqueBa, VueHtml2pdf },
  data() {
    return {
      htmlToPdfOptions: {
        filename: `estoque-ba.pdf`,
        margin: [10, 10, 10, 10],
        image: {
          type: 'jpeg',
          quality: 1,
        },
        html2canvas: {
          scale: 2,
          logging: true,
          dpi: 192,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compressPDF: true,
        },
      },
      isLoading: false,

      options: [
        { value: '1', text: '1º Semestre' },
        { value: '2', text: '2º Semestre' },
      ],
      estoqueRequest: {
        data_inicial: '',
        data_final: '',
        semestreSelected: null,
      },
      isSubmit: false,
      estoques: [],
    }
  },
  watch: {
    estoqueRequest: {
      handler: function (val, oldVal) {
        this.isSubmit = false
      },
      deep: true,
    },
  },
  methods: {
    gerar() {
      if (this.semestreSelected !== '') {
        this.isLoading = true
        const token = this.$store.state.auth.currentUser.token
        arquivo
          .generateAndDownloadBA(token, this.estoqueRequest)
          .then((response) => {
            this.isLoading = false
            this.estoques = response.data.data
            this.$bvModal.show('rel-ba')
          })
          .catch((err) => {
            this.isLoading = false
            this.$bvToast.toast(
              err.response.data.msg || 'Ecorreu um erro ao gerar relatório',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
          })
      } else {
        this.isSubmit = true
        this.$bvToast.toast('Preencha os campos de obrigatórios!', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const vue = this
      this.isLoading = true
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          vue.isLoading = false
        })
        .save()
    },
  },
}
</script>

<style>
.empty {
  border: 1px solid red;
}
</style>